<div class="container-fluid">
  <div class="position-relative">
    <!-- Header -->
    <div class="header-section mb-3">
      <div class="row align-items-center">
        <div class="col-md-8">
          <h1 class="page-title">
            <i class="fa fa-list-alt"></i> Catálogo de Trámites
          </h1>
          <p class="page-subtitle">Gestiona y consulta todos los trámites municipales disponibles</p>
        </div>
        <div class="col-md-4 text-end">
          <button type="button" class="btn btn-primary btn-lg" (click)="agregarNuevoTramite()">
            <i class="fa fa-plus-circle"></i> Agregar Nuevo Trámite
          </button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body" style="padding: 0;">
        <!-- Barra de Búsqueda -->
        <div class="search-bar">
          <div class="flex-grow-1 mr-1 search-container">
            <i class="fa fa-search search-icon" aria-hidden="true"></i>
            <input 
              placeholder="Buscar por nombre, código, tipo, categoría o área" 
              class="form-control search-input" 
              id="validationCustom1" 
              type="text" 
              [(ngModel)]="searchValue"
              (keyup.enter)="applyFilters()">
          </div>
          <div class="mr-1">
            <button class="btn btn-primary btn-buscar" (click)="applyFilters()">Buscar</button>
          </div>
          <div>
            <button class="btn btn-primary btn-filtros" (click)="toggleSearchMenu()">
              <i class="fa fa-filter" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <!-- Barra de Búsqueda -->

        <!-- Menú de Filtros -->

        <!-- Loading -->
        <div *ngIf="isLoading" class="loading-container" style="padding: 50px; text-align: center;">
          <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
          <p class="mt-3">Cargando catálogo de trámites...</p>
        </div>

        <!-- Tabla -->
        <div *ngIf="!isLoading" class="table-responsive">
          <table mat-table class="table" matSort (matSortChange)="sortData($event)" [dataSource]="dataSource">
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="nombre" class="titulos">NOMBRE DEL TRÁMITE</th>
              <td mat-cell *matCellDef="let item">{{ item.Form?.FormsCommon?.Name || '-' }}</td>
            </ng-container>
            
            <ng-container matColumnDef="codigo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="codigo" class="titulos">CÓDIGO</th>
              <td mat-cell *matCellDef="let item">{{ item.Form?.FormsCommon?.Code || '-' }}</td>
            </ng-container>
            
            <ng-container matColumnDef="tipo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="tipo" class="titulos">TIPO</th>
              <td mat-cell *matCellDef="let item">{{ item.Form?.FormsCommon?.Type || '-' }}</td>
            </ng-container>
            
            <ng-container matColumnDef="categoria">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="categoria" class="titulos">CATEGORÍA</th>
              <td mat-cell *matCellDef="let item">{{ item.Category?.Name || '-' }}</td>
            </ng-container>
            
            <ng-container matColumnDef="area">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="area" class="titulos">ÁREA</th>
              <td mat-cell *matCellDef="let item">{{ item.Area?.Name || '-' }}</td>
            </ng-container>
            
            <ng-container matColumnDef="tiempo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="tiempo" class="custom-h-fecha">TIEMPO DE RESPUESTA</th>
              <td mat-cell *matCellDef="let item" class="custom-c-fecha">{{ formatTime(item.Form?.FormsCommon?.AnswerTime, item.Form?.FormsCommon?.AnswerTimeType) }}</td>
            </ng-container>
            
            <ng-container matColumnDef="modalidad">
              <th mat-header-cell *matHeaderCellDef class="custom-h-estatus">MODALIDAD</th>
              <td mat-cell *matCellDef="let element" class="custom-c-estatus">
                <span class="badge" [ngClass]="'bg-' + getModalidadColor(element.Form?.FormsCommon?.IsOnline)">
                  {{ getModalidad(element.Form?.FormsCommon?.IsOnline) }}
                </span>
              </td>
            </ng-container>
            
            <ng-container matColumnDef="verDetalle">
              <th mat-header-cell *matHeaderCellDef class="custom-h-verdetalle">DETALLE</th>
              <td mat-cell *matCellDef="let item" class="custom-c-verdetalle">
                <button 
                  mat-icon-button 
                  (click)="verDetalles(item, detalleModal)" 
                  class="boton-detalle verdetalle"
                  title="Ver detalles">
                  <i class="fa fa-eye"></i>
                </button>
              </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <!-- Tabla -->

        <!-- Sin resultados -->
        <div *ngIf="!isLoading && filteredTramites.length === 0" class="no-results" style="padding: 50px; text-align: center;">
          <i class="fa fa-inbox fa-4x text-muted"></i>
          <h4 class="mt-3">No se encontraron trámites</h4>
          <p class="text-muted">Intenta ajustar los filtros de búsqueda</p>
          <button class="btn btn-primary mt-3" (click)="clearFilters()">
            <i class="fa fa-refresh"></i> Limpiar Filtros
          </button>
        </div>
        
        <!-- Paginación -->
        <div *ngIf="!isLoading && totalPages > 0" style="padding: 15px;">
          <ngb-pagination 
            [collectionSize]="totalRecords" 
            [(page)]="currentPage" 
            [pageSize]="limit" 
            [maxSize]="5"
            [rotate]="true"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)">
          </ngb-pagination>
        </div>
      </div>
    </div>
        
    <div *ngIf="showSearchMenu" id="search-menu" class="menu-container right-menu menu-open position-absolute p-3">
        <div class="d-flex align-items-center mb-3">
            <i class="fa fa-filter" aria-hidden="true"></i>
            <h3 class="mb-0 ml-2">Filtro</h3>
            <button type="button" class="close ml-auto" aria-label="Close" (click)="toggleSearchMenu()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="form-group mb-2">
            <label for="dependencia">Dependencia:</label>
            <select class="form-control" id="dependencia" [(ngModel)]="selectedDependencia">
                <option value="">Todas las dependencias</option>
                <option *ngFor="let dependencia of dependencias" [value]="dependencia.Name">{{ dependencia.Name }}</option>
            </select>
        </div>

        <div class="form-group mb-2">
            <label for="area">Área:</label>
            <select class="form-control" id="area" [(ngModel)]="selectedArea">
                <option value="">Todas las áreas</option>
                <option *ngFor="let area of areas" [value]="area.Name">{{ area.Name }}</option>
            </select>
        </div>

        <div class="form-group mb-2">
            <label for="solicitante">Solicitante:</label>
            <select class="form-control" id="solicitante" [(ngModel)]="selectedSolicitante">
                <option value="">Todos los solicitantes</option>
                <option *ngFor="let tipo of tiposSolicitante" [value]="tipo">{{ tipo }}</option>
            </select>
        </div>
        <div class="d-flex justify-content-between menu-buttons mt-3">
            <button class="btn btn-sm mr-1 btn-filtrar" (click)="applyFilters()">Filtrar</button>
            <button class="btn btn-sm btn-limpiar" (click)="clearFilters()">Limpiar</button>
        </div>
    </div>
  </div>
</div>

<!-- Modal de Detalles -->
<ng-template #detalleModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      <i class="fa fa-info-circle"></i> Detalles del Trámite
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="closeModal()" aria-label="Close"></button>
  </div>

  <div class="modal-body" *ngIf="isLoadingDetails">
    <div class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
      <p class="mt-3">Cargando detalles...</p>
    </div>
  </div>

  <div class="modal-body" *ngIf="!isLoadingDetails && tramiteDetalles">
    <!-- Información principal -->
    <div class="tramite-detail-header mb-4">
      <h4 class="text-primary">{{ tramiteDetalles.Form?.FormsCommon?.Name }}</h4>
      <p class="text-muted mb-2">
        <i class="fa fa-barcode"></i> {{ tramiteDetalles.Form?.FormsCommon?.Code }}
      </p>
      <div class="detail-badges">
        <span class="badge bg-info">{{ tramiteDetalles.Form?.FormsCommon?.Type }}</span>
        <span class="badge" [ngClass]="'bg-' + getModalidadColor(tramiteDetalles.Form?.FormsCommon?.IsOnline)">
          {{ getModalidad(tramiteDetalles.Form?.FormsCommon?.IsOnline) }}
        </span>
        <span class="badge bg-secondary">{{ tramiteDetalles.Category?.Name }}</span>
      </div>
    </div>

    <!-- Descripción -->
    <div class="detail-section mb-3" *ngIf="tramiteDetalles.Form?.FormsDetail?.Description">
      <h6><i class="fa fa-file-text text-primary"></i> Descripción</h6>
      <p>{{ tramiteDetalles.Form?.FormsDetail?.Description }}</p>
    </div>

    <!-- Detalles en grid -->
    <div class="row g-3 mb-3">
      <div class="col-md-6">
        <div class="detail-item">
          <i class="fa fa-building text-primary"></i>
          <div>
            <strong>Área</strong>
            <p class="mb-0">{{ tramiteDetalles.Area?.Name || '-' }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="detail-item">
          <i class="fa fa-clock text-primary"></i>
          <div>
            <strong>Tiempo de Respuesta</strong>
            <p class="mb-0">{{ formatTime(tramiteDetalles.Form?.FormsCommon?.AnswerTime, tramiteDetalles.Form?.FormsCommon?.AnswerTimeType) }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="tramiteDetalles.Form?.FormsCommon?.Validity">
        <div class="detail-item">
          <i class="fa fa-calendar text-primary"></i>
          <div>
            <strong>Vigencia del Documento</strong>
            <p class="mb-0">{{ tramiteDetalles.Form?.FormsCommon?.Validity }} {{ tramiteDetalles.Form?.FormsCommon?.ValidityType }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Fundamentos jurídicos -->
    <div class="detail-section mb-3" *ngIf="tramiteDetalles.Form?.FormsDetail?.LegalBase">
      <h6><i class="fa fa-gavel text-primary"></i> Fundamentos Jurídicos</h6>
      <p>{{ tramiteDetalles.Form?.FormsDetail?.LegalBase }}</p>
    </div>

    <!-- Contacto -->
    <div class="detail-section" *ngIf="tramiteDetalles.Form?.FormsInquiry">
      <h6><i class="fa fa-phone text-primary"></i> Información de Contacto</h6>
      <div class="row g-3">
        <div class="col-md-6">
          <p><strong>Atendido por:</strong> {{ tramiteDetalles.Form?.FormsInquiry?.Attender || '-' }}</p>
          <p><strong>Teléfono:</strong> {{ tramiteDetalles.Form?.FormsInquiry?.Phone || '-' }}</p>
        </div>
        <div class="col-md-6">
          <p><strong>Email:</strong> {{ tramiteDetalles.Form?.FormsInquiry?.Email || '-' }}</p>
          <p><strong>Horario:</strong> {{ tramiteDetalles.Form?.FormsInquiry?.Schedule || '-' }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      <i class="fa fa-times"></i> Cerrar
    </button>
    <button type="button" class="btn btn-info" (click)="verTramiteCompleto(tramiteDetalles.Form?.id)">
      <i class="fa fa-eye"></i> Ver Completo
    </button>
  </div>
</ng-template>
